import { Injectable } from "@angular/core";
import { TeamCardsDto } from "app/models/dtos/team-cards.dto";
import { Observable } from "rxjs";
import { ConfigurationService, HttpService } from ".";
import { BaseService } from "./base.service";

@Injectable()
export class StadiumService extends BaseService {
    
    constructor(httpService: HttpService,
        configurationService: ConfigurationService) {
            super(httpService, configurationService);
    }

    setupPrice(price: number): Observable<any> {
        return this.httpService.put<any>(this.apiUrl + 'stadium/price', null, {price: price});
    }
}